import { IconButton, Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import Iconify from "minimals-template/components/Iconify"
import { getMaintenanceTask } from "routes/component-library/controller/maintenance-library"
import { parseComponentTokenId } from "authoring/routes/macro/lib/parse-component-token-id"
import { withComparison } from "lib/graphql/comparison-function"
import { isSame } from "library/normalized-stringify/index.mjs"

export function ComponentInUseItem({ item: tokenId }) {
    const { onSelect } = useBoundContext()
    const parsed = parseComponentTokenId(tokenId)
    const task = getMaintenanceTask.useResults(
        parsed?.taskId,
        withComparison((left, right) => isSame(left, right, { invalidChars: [] }))
    )

    if (!task) return null

    return (
        <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
                py: 1.25,
                borderBottom: "1px dashed",
                borderColor: "divider",
                cursor: "pointer",
                "&:last-child": { borderBottom: "none" },
            }}
            onClick={handleSelect}
        >
            <TruncatedTypography variant="body2" sx={{ flex: 1, minWidth: 0 }}>
                {task.heading || "Untitled Task"}
            </TruncatedTypography>
            <IconButton aria-label="View task" size="small" sx={{ flexShrink: 0 }}>
                <Iconify icon="mdi:chevron-right" />
            </IconButton>
        </Stack>
    )

    function handleSelect() {
        onSelect?.(tokenId)
    }
}
